export const config = {
  mixins: [],
  data() {
    return {
      columns: [],
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [];
      if(this.moduleCode == 'ACTIVITY_SUMMARY') {
        columns.push({
          title: '保险公司',
          key: 'companyName',
          minWidth: 100,
          align: 'center'
        })
      }
      columns.push({
        title: this.moduleCode == 'ACTIVITY_SUMMARY' ? '活动名称' : '标题名称',
        slot: 'title',
        minWidth: 200,
        align: 'center'
      })
      if(['MARKET_TOOLS', 'COMMON_USE_TOOLS', 'PERIPHERY_SERVICE', 'HOT_SPOT'].includes(this.moduleCode)) {
        columns.push({
          title: '所属栏目',
          key: 'columnName',
          minWidth: 100,
          align: 'center'
        })
      }
      columns = columns.concat([
        {
          title: '文章类型',
          key: 'type',
          width: 100,
          align: 'center',
          render(h, params) {
            const value = params.row.type;
            const map = {
              1: '图文',
              2: '海报',
              3: 'PDF'
            };
            return <div>{map[value] || '-'}</div>;
          }
        },
        {
          title: '上架时间',
          key: 'useTime',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            const value = params.row.useTime ? params.row.useTime.substr(0, 16): '-';
            return <div>{value}</div>;
          }
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 120,
          fixed: 'right'
        }
      ]);
      this.columns = columns;
    }
  }
};